import type { Sequence } from "../types/Sequence"

export function* Map<T, N>(
  func: (item: T, index: number) => N,
  ...arrays: Sequence<T>[]
): Iterable<N> {
  for (const array of arrays) {
    let index = 0
    for (const item of array) {
      yield func(item, index++)
    }
  }
}
